import React from "react";
import AuthScreen from "../components/Auth/AuthScreen";

const ForgotPassword = () => {
  return <AuthScreen initialMode="reset" />;
};

export default ForgotPassword;
